import { notificationSavedViewFilterSetsToFilterSets } from '~/client/src/shared/lists/notifications/notificationFilterVocabulary'
import {
  NotificationsListStore,
  NotificationTab,
} from '~/client/src/shared/lists/notifications/NotificationsList.store'

export function applyNotificationSavedView(
  store: NotificationsListStore,
  filters: { [key: string]: Set<string> },
  _legacyGroupBy?: string,
): void {
  store.setTab(NotificationTab.All, { preserveSearch: true })
  store.applyFilterSets(notificationSavedViewFilterSetsToFilterSets(filters))
}
